import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { Modal, Input, DatePicker, Dropdown, Menu, Button, Icon, Spin, Empty } from 'antd';
import { getManuscriptList, getManuscriptTimeList } from "../../../../actions/resourceWrap";
import Scrollbars from 'react-custom-scrollbars';
import taskSelected from '../../../../view/components/manuscriptPool/img/card2.png';
import taskUnselected from '../../../../view/components/manuscriptPool/img/otherCard.png';
import timeSelected from '../../../../view/components/manuscriptPool/img/list2.png';
import timeUnselected from '../../../../view/components/manuscriptPool/img/otherList.png';
import PictureItem from '../pictureItem';
import './index.scss';



const { confirm } = Modal
const { Search } = Input
const { RangePicker } = DatePicker

const Manuscript = (props) => {

    const [time, setTime] = useState([]);
    const [keyWords, setKeyWords] = useState('');
    const [current, setCurrent] = useState(1);
    const [total, setTotal] = useState(0);
    const [pageSize, setPageSize] = useState(4);

    const [showType, setshowType] = useState('manuscript');  //列表以什么视图展示  task \ time 
    const [manuscriptType, setManuscriptType] = useState(1);  // 1是原创稿件 2 是投稿稿件
    const [manuscriptData, setManuscriptData] = useState([]);  //稿件图片列表的数据
    const [loading, setLoading] = useState(false);
    const [text, setText] = useState(''); //分页文字
    const scrollRef = useRef();

    let timeOut;

    useEffect(() => {
        if (time.length === 0 || time.length === 2) {
            search();
        }
        return () => {
            clearTimeout(timeOut);
        }
    }, [time, manuscriptType, showType])

    const changeshowType = (e) => {
        //console.log(e.target.getAttribute('data-type'))
        setKeyWords('');
        setTime([]);
        setCurrent(1);
        setTotal(0);
        setText('');
        scrollRef.current.scrollToTop();
        let type = e.target.getAttribute('data-type')
        if (showType === 'manuscript') {
            if (type === 'time') {
                setshowType('manuscript-time');
            }
        } else {
            if (type === 'manuscript') {
                setshowType('manuscript');
            }
        }
    }

    const handleMenuChange = (e) => {
        setCurrent(1);
        setTotal(0);
        setText('');
        if (e.item.props.children === '原创稿件') {
            setManuscriptType(1);
        } else {
            setManuscriptType(2);
        }
    }

    const getParams = () => {
        const startDate = time.length === 0 ? '' : moment(time[0]).startOf('day').format('x');
        const endDate = time.length === 0 ? '' : moment(time[1]).endOf('day').format('x');
        const queryStr = keyWords !== undefined ? keyWords : ''
        const type = manuscriptType !== undefined ? manuscriptType : ''
        const params = { storyTitle: queryStr, startDate: startDate, endDate: endDate, storyType: type }
        return params
    }

    const search = () => {
        let params = getParams();
        let { title } = props;
        let searchName = '';
        let type = 1;
        if (showType === 'manuscript') {
            searchName = getManuscriptList
        }
        if (showType === 'manuscript-time') {
            searchName = getManuscriptTimeList
        }
        if (title === '图片池') {
            type = 1
        }
        if (title === '视频池') {
            type = 2
        }
        if (title === '附件池') {
            type = 3
        }
        setLoading(true)
        searchName({ start: current, size: pageSize, ...params, type }, function (res) {
            setLoading(false)
            if (res.code === 0) {
                let listData = [];
                for (let i = 0; i < res.data.length; i++) {
                    listData.push({ title: res.data[i].storyTitle ? res.data[i].storyTitle : res.data[i].date, fileList: res.data[i].pictureList ? res.data[i].pictureList : (res.data[i].videoList ? res.data[i].videoList : [...res.data[i].audioList, ...res.data[i].otherFileList]) })
                }
                setTotal(res.count);
                setManuscriptData(listData);
            }
        })
    }

    const renderList = () => {
        return (
            <Menu onClick={handleMenuChange} selectable>
                <Menu.Item key={1}>
                    原创稿件
                </Menu.Item>
                <Menu.Item key={2}>
                    投稿稿件
                </Menu.Item>
            </Menu>
        )
    }

    const onScroll = (e) => {
        if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
            // console.log(e.target.scrollTop)  //滚动条距离顶部的距离
            // console.log(e.target.clientHeight) //滚动区域的高度
            // console.log(e.target.scrollHeight)
            // console.log('滚动到底部啦')
            //判断有无下一页
            // let data =  manuscriptData;  //数据总条数    当前已经获取到的数据总数 每页展示多少个
            //    console.log(total);
            //    console.log(manuscriptData) 

            if (total > manuscriptData.length) {
                //说明还有下一页，需要请求下一页的数据 展示 '加载更多'
                setText('正在加载中')
                // console.log('请求下一页数据')
                let start = current + 1;
                let params = getParams();
                let { title } = props
                let searchName = '';
                let type = 1;  // tupian  视频 附件
                if (showType === 'manuscript') {
                    searchName = getManuscriptList
                }
                if (showType === 'manuscript-time') {
                    searchName = getManuscriptTimeList
                }
                if (title === '图片池') {
                    type = 1
                }
                if (title === '视频池') {
                    type = 2
                }
                if (title === '附件池') {
                    type = 3
                }
                timeOut = setTimeout(() => {
                    searchName({ start, size: pageSize, ...params, type }, function (res) {
                        if (res.code === 0) {
                            let listData = [];
                            for (let i = 0; i < res.data.length; i++) {
                                listData.push({ title: res.data[i].storyTitle ? res.data[i].storyTitle : res.data[i].date, fileList: res.data[i].pictureList ? res.data[i].pictureList : (res.data[i].videoList ? res.data[i].videoList : [...res.data[i].audioList, ...res.data[i].otherFileList]) })
                            }
                            setManuscriptData([...manuscriptData, ...listData]);
                            setCurrent(start);
                            setText('');
                        }
                    })

                }, 0)
            } else {
                setText('已加载全部');
                //说明没有下一页，展示 ''
            }
        }
    }

    return (
        <>
            <div className="manuscript-condition">
                <div>
                    <div>
                        <Dropdown overlay={renderList()} arrow={true}>
                            <Button>
                                {manuscriptType === 1 ? '原创稿件' : '投稿稿件'}<Icon type="down" />
                            </Button>
                        </Dropdown>
                    </div>
                    <div>
                        <span style={{ marginRight: 10 }} className="text">创建时间</span>
                        <RangePicker value={time} allowClear onChange={(dates) => setTime(dates)} />
                    </div>
                    <div>
                        {
                            showType === 'manuscript' ? <Search placeholder="请输入搜索内容" value={keyWords} onChange={(e) => setKeyWords(e.target.value)} onSearch={() => { search() }} /> : ''
                        }
                    </div>
                    <div style={{padding:"0px"}}>
                        <img style={{width:"35px",height:"35px",objectFit:"cover",minHeight:"100%"}} src={`${showType === 'manuscript' ? taskSelected : taskUnselected}`} alt="" onClick={changeshowType} data-type="manuscript" />
                    </div>
                    <div style={{padding:"0px"}}>
                        <img style={{width:"35px",height:"35px",objectFit:"cover",minHeight:"100%"}} src={`${showType === 'manuscript-time' ? timeSelected : timeUnselected}`} alt="" onClick={changeshowType} data-type="time" />
                    </div>
                </div>
            </div>
            <div className="manuscript-content" >
                <Scrollbars onScroll={onScroll} ref={scrollRef}>
                    {
                        loading ? <Spin spinning={loading} className="loading" /> : (
                            manuscriptData.length === 0 ? <Empty className="noData" /> :
                                manuscriptData.map((item, index) => (
                                    <PictureItem itemData={item} showType={showType} title={props.title} key={index} />))
                        )
                    }
                    {
                        text === '' ? '' : (text === '正在加载中' ? <Spin style={{ width: '100%' }} indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} /> : <span style={{ display: 'block', width: '100%', textAlign: 'center' }}>已加载全部</span>)

                    }
                </Scrollbars>


            </div>

        </>
    )
}



export default Manuscript